import * as React from 'react'

import { LoginHeading } from '@ally/ally-login'
import { Button, Space } from '@ally/metronome-ui'
import { AsyncStatus } from '@ally/transmitigator'

import { useAppState } from '../../AppStateProvider'
import { useTransmit } from '../../TransmitContext'
import { getAAOSForgotPasswordUrl, getAAOSForgotUsernameUrl } from '../../Utils'
import { StyledTextBody } from '../Shared'

interface AutoForgotUsernamePasswordProps {
  error: string
  status: AsyncStatus
}

const AutoForgotUsernamePasswordContent: React.FC<AutoForgotUsernamePasswordProps> = ({
  error,
  status,
}) => {
  const { isWebWrapped } = useAppState()
  const { hostServices } = useTransmit()

  const copyText = isWebWrapped
    ? 'Head over to the Ally Auto app to continue.'
    : 'Head over to Ally Auto to Continue.'

  const handleClick = (): void => {
    if (isWebWrapped) {
      window.location.href = 'ally://autoapp-forgotusername'
    } else if (error === 'CIAM_E01_07_002') {
      // Forgot Password
      window.location.href = getAAOSForgotPasswordUrl()
    } else if (error === 'CIAM_E08_07_007') {
      // Forgot Username
      window.location.href = getAAOSForgotUsernameUrl()
    }
  }

  React.useEffect(() => {
    hostServices?.analytics.trackPageView({
      eventType: 'pageview',
      pageName:
        error === 'CIAM_E01_07_002'
          ? 'AOS:Login:Forgot Password:Go to Ally Auto'
          : 'AOS:Login:Forgot Username:Go to Ally Auto',
    })
  }, [])

  return (
    <>
      <LoginHeading title="Almost there" />

      <Space mb="lg">
        <StyledTextBody size="sm" tag="p">
          {copyText}
        </StyledTextBody>
      </Space>

      <Button
        allytmln="goToAllyAuto"
        loading={status === 'Loading'}
        onClick={handleClick}
        text="Go to Ally Auto"
        type="submit"
        variant="primary"
      />
    </>
  )
}

export const AutoForgotUsernamePassword: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'AutoForgotUsernamePassword') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <AutoForgotUsernamePasswordContent {...activeScreen.payload} />
}
